import React from 'react';
import { CellProps } from 'react-table';
import { ApplicationsTableRow } from '../common/types/types';
import { ApplicationLocationCell } from '../common/types/applications-table-row';

export const OffersLocationCell = ({ value }: CellProps<ApplicationsTableRow, ApplicationLocationCell>) => {
  const { location } = value;
  return <span>{location}</span>;
};
